import { type Filter } from 'src/components/common/tokenized-search-field';

/**
 * Converts tokenized search filters into MongoDB-style regex filters with case-insensitive matching.
 *
 * @param filters - Array of Filter objects from TokenizedSearchField
 * @param defaultScope - Default attribute to filter by if no scope is specified (e.g., 'name')
 * @returns MongoDB-style filter object with $regex and $options
 */
export const buildRegexFilters = (
  filters: Filter[],
  defaultScope: string = 'name'
): Record<string, object> => {
  if (filters.length === 0) {
    return {};
  }

  const filtersByAttribute: Record<string, string[]> = {};

  filters.forEach(filter => {
    const attr = filter.scope ?? defaultScope;
    if (!filtersByAttribute[attr]) {
      filtersByAttribute[attr] = [];
    }
    filtersByAttribute[attr].push(filter.term);
  });

  const apiFilters: Record<string, object> = {};

  Object.entries(filtersByAttribute).forEach(([attr, terms]) => {
    apiFilters[attr] = {
      $regex: terms.join('|'),
      $options: 'i', // case-insensitive
    };
  });

  return apiFilters;
};
